// @ts-nocheck
import { useMutation, useQueryClient } from 'react-query';
import { useRequestQuery } from '../useQueryRequest';
import useApiRequest from '../useRequest';
import t from './types';

/**
 * Retrieve the carriers list.
 */
export function useCarriers(props?) {
  return useRequestQuery(
    [t.CARRIERS],
    { method: 'get', url: 'carriers' },
    {
      select: (res) => res.data.carriers,
      defaultData: [],
      ...props,
    },
  );
}

/**
 * Retrieve a single carrier by ID.
 */
export function useCarrier(id, props?) {
  return useRequestQuery(
    [t.CARRIER, id],
    { method: 'get', url: `carriers/${id}` },
    {
      select: (res) => res.data.carrier,
      defaultData: {},
      enabled: !!id,
      ...props,
    },
  );
}

/**
 * Create 
 */
export function useCreateCarrier(props?) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation((values) => apiRequest.post('carriers', values), {
    onSuccess: () => {
      // Invalidate carriers.
      queryClient.invalidateQueries(t.CARRIERS);
    },
    ...props,
  });
}

/**
 * Edit 
 */
export function useEditCarrier(props?) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation(
    ([id, values]) => apiRequest.post(`carriers/${id}`, values),
    {
      onSuccess: () => {
        // Invalidate carriers.
        queryClient.invalidateQueries(t.CARRIERS);
        queryClient.invalidateQueries(t.CARRIER);
      },
      ...props,
    },
  );
}

/**
 * Delete 
 */
export function useDeleteCarrier(props?) {
  const queryClient = useQueryClient();
  const apiRequest = useApiRequest();

  return useMutation((id) => apiRequest.delete(`carriers/${id}`), {
    onSuccess: () => {
      // Invalidate carriers.
      queryClient.invalidateQueries(t.CARRIERS);
    },
    ...props,
  });
}